import { useCallback, useContext, useMemo } from 'react';
import { SessionContext } from 'auth/SessionProvider';
import { PermissionKey } from 'constants/permissionKeys';

// The signed-in admin's permissions, exactly as /me computed them. Components ask; they never decide.
export function useAccess() {
  const { user } = useContext(SessionContext);
  const permissions = user?.access?.permissions;

  const granted = useMemo(() => new Set<string>(permissions ?? []), [permissions]);
  const can = useCallback((key: PermissionKey) => granted.has(key), [granted]);
  const canAny = useCallback(
    (...keys: PermissionKey[]) => keys.some(key => granted.has(key)),
    [granted],
  );

  return { can, canAny, isLoaded: permissions !== undefined };
}
